/* BackupDetailComponent.js */

"use strict";

const _ = require("lodash");
const Renderer = require("./BackupDetailRenderer");
const EventEmitter = require("events").EventEmitter;
const ScheduleVeilComponent = require("../../../../../../lib/actions/veils/schedule/ScheduleVeilComponent");

class BackupDetailComponent extends EventEmitter {
    constructor(logger, GameEditor, message, selectedDevices, ValueMap) {
        super(logger, GameEditor, message, selectedDevices, ValueMap);
        this._message = message;
        this._gameEditor = GameEditor;
        this._selectedDevices = selectedDevices;
        this._valueMap = ValueMap;
        this._title = "Backup Devices";
        this.devices = Array.isArray(this._gameEditor._activeView.selectedRows)
            ? this._gameEditor._activeView.selectedRows
            : {};
        this._hasBasicSearch = !_.isEmpty(
            _.get(
                this._gameEditor._activeView._userGridData.getBasicSearchData(),
                "filterQuery",
                {}
            )
        );
        this._renderer = new Renderer(this);
        this._renderer.render();
        this._context = undefined;
    }

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    async shutdown() {
        try {
            await this._renderer.shutdown();
            this._message = this._title = this._renderer = this._context = undefined;
        } catch (err) {
            this._logger.warn({error: err}, "BaseCreateComponent.shutdown() error");
        }
    }

    backupAction(name, runCapture) {
        const query = Array.isArray(this.devices)
            ? {$and: [{id: {$in: this.devices}}]}
            : this.devices;
        this._context.resolve({name, runCapture, query});
    }

    async scheduleBackup(scheduleName, workInput, selType) {
        let query = {};
        let ids = [];

        if (selType === "current_search_results") {
            this._deviceIds = await this._gameEditor._activeView._DeviceEntityDef.loadDevices(
                this._gameEditor._activeView.activeOrgId,
                _.get(
                    this._gameEditor._activeView._userGridData.getBasicSearchData(),
                    "filterQuery",
                    {}
                ),
                {id: true}
            );
            this._deviceIds = this._deviceIds.map((dev) => dev.id);
            this.devices = this._deviceIds;
        }
        if (Array.isArray(this.devices)) {
            ids = this.devices;
        } else {
            query = this.devices;
        }

        let workTarget = {
            method:
                selType === "selection" || selType === "current_search_results" ? "multi" : "query",
            category: "entity",
            entityType: "Device",
        };

        if (selType === "selection" || selType === "current_search_results") {
            workTarget.ids = ids;
        } else {
            workTarget.query = query;
        }

        const titleMsg = "Schedule Backup";

        try {
            const scheduleDef = await this._gameEditor._modalUserFeedback.displayCustom(
                new ScheduleVeilComponent(this._logger, true, titleMsg, {
                    workType: "backup",
                    soln: undefined,
                    selectedRowsCount: this._gameEditor._activeView.selectedRows.length || 0,
                }),
                {
                    dontHide: false,
                }
            );

            let schedule = scheduleDef.schedule;

            // For PE-10982 - to add the notification settings on workInput
            Object.assign(workInput, scheduleDef.workInput);

            // backdoor to allow every minute schedules for internal testing
            if (_.get(schedule, "every.hour") && name === "everymin") {
                _.set(schedule, "every.minute", schedule.every.hour);
                delete schedule.every.hour;
            }

            this._gameEditor._deviceEntity.scheduleBackupWork(
                this._gameEditor._activeView.activeOrgId,
                scheduleName,
                "",
                schedule,
                workTarget,
                workInput
            );

            return Promise.resolve();
        } catch (err) {
            return Promise.reject(err);
        }
    }

    cancelAction() {
        this._context.reject({userRejected: true});
    }

    getSupportedOs() {
        return this._valueMap
            .loadVendorOsMapEntity(this._gameEditor._activeView.activeOrgId)
            .then((vendorOsMapEntity) => {
                const backupRestoreVendorOsMap =
                    (vendorOsMapEntity &&
                        vendorOsMapEntity.filterVendorOsMapByOsProp(
                            "supportedFeatures.backupAndRestore",
                            true
                        )) ||
                    {};
                const supportedOSs = Object.values(backupRestoreVendorOsMap).reduce((acc, item) => {
                    for (const os of Object.values(item.os)) {
                        acc.push(os.displayName);
                    }
                    return acc;
                }, []);
                this._supportedOsList = supportedOSs;
                return Promise.resolve();
            });
    }

    set "$teve.ui.context"(context) {
        this._context = context;
    }
}

module.exports = BackupDetailComponent;
